<template>
  <div>
    <div class="bv-example-row">
      <router-link to="/contracts/add">
        <b-button size="lg" variant="primary" class="mb-4">
          <v-icon>mdi-plus</v-icon>
          Add Contract
        </b-button>
      </router-link>
      <b-card-group deck>
        <b-card
          v-for="contract in contracts"
          v-bind:key="contract.contract_id"
          header-tag="header"
          class="my-grid card mb-3"
          :id="'search-result-' + contract.product_id"
        >
          <template v-slot:footer style="display:none"></template>
          <template>
            <h4>{{ contract.product.title }}</h4>
            <b-card-text>
              <strong>{{ contract.alias }}</strong> <br />
              <strong v-if="contract.group && contract.group.name"
                >Group: {{ contract.group.name }}</strong
              >
            </b-card-text>
            <b-button
              @click="
                handleProduct(
                  contract.product.product_id,
                  contract.product.title,
                  contract.contract_id,
                  contract.channel_id,
                  contract.credentials,
                  contract.igb_customer_id
                )
              "
              href="#"
              variant="secondary"
              size="sm"
              >{{
                productInBasket(
                  contract.product.product_id,
                  contract.contract_id
                )
                  ? "Remove from campaign"
                  : "Add to campaign"
              }}
            </b-button>
            <router-link :to="'/contracts/details/' + contract.contract_id">
              <span class="align-middle mt-2 float-right">More info</span>
            </router-link>
          </template>
        </b-card>
      </b-card-group>
    </div>
    <div class="d-flex mt-3">
      <b-button
        variant="primary"
        :disabled="!previous"
        @click="getContracts(previous)"
      >
        <v-icon>mdi-chevron-left</v-icon>
        Back
      </b-button>
      <b-button
        variant="primary ml-4"
        :disabled="!next"
        @click="getContracts(next)"
      >
        <v-icon>mdi-chevron-right</v-icon>
        Next
      </b-button>
    </div>
  </div>
</template>

<script>
import { HapiService } from "@/core/services/hapi.service";
import { BasketService } from "@/core/services/basket.service";

export default {
  name: "ListContracts",
  data() {
    return {
      contracts: [],
      next: null,
      previous: null,
      limit: 10
    };
  },
  methods: {
    productInBasket(productId, contractId) {
      return BasketService.hasProduct(productId, contractId);
    },
    handleProduct(
      productId,
      productName,
      contractId,
      channelId,
      contractCredentials,
      customerId
    ) {
      if (this.productInBasket(productId, contractId)) {
        BasketService.removeProduct(productId, contractId);
      } else {
        BasketService.addProduct(
          productId,
          productName,
          contractId,
          channelId,
          contractCredentials,
          undefined,
          undefined,
          undefined,
          undefined,
          customerId
        );
      }
      this.$forceUpdate();
    },
    async getContracts(url) {
      const { data } = await HapiService.listContracts(url);
      this.contracts = data.results;
      this.next = data.next;
      this.previous = data.previous;
    }
  },
  async mounted() {
    const { data } = await HapiService.listContracts({
      params: {
        limit: this.limit,
        offset: 0
      }
    });
    this.contracts = data.results;
    this.next = data.next;
    this.previous = data.previous;
  }
};
</script>

<style scoped>
.card {
  min-width: auto !important;
}

.full-width {
  width: 100%;
}

.hide {
  display: none;
  visibility: hidden;
}

.my-grid {
  display: grid;
  justify-items: center;
  /* 280px is the minimum a column can get, you might need to adjust it based on your needs. */
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  grid-gap: 1rem;
  flex: unset;
}

.my-grid > * {
  width: 100%;
  max-width: 26rem;
}
</style>
